<app-header-banner
  title="How to Videos"
  imageUrl="./assets/header-banner/how-to-video-banner-graphic.svg" />

<div class="card">
  <div class="card-body">
    <div class="mb-3">
      <div class="row gy-2">
        <div class="col-auto">
          <app-search-field [searchOptions]="videosSearchOptions"></app-search-field>
        </div>
        @if (videoTags) {
          <div class="col-auto">
            <app-tag-filter [tags]="videoTags"></app-tag-filter>
          </div>
        }
      </div>
    </div>

    @if (!isLoading) {
      <div
        class="row gy-3 video-wrapper"
        [ngClass]="{ 'row-cols-1 row-cols-sm-2 row-cols-xl-3': videoData?.length }">
        @for (video of videoData; track video) {
          <div class="col">
            <div class="card mb-1">
              <div class="card-body p-3 p-lg-4">
                <app-video-player
                  [videoTitle]="video.title"
                  [videoUrl]="video.url"
                  [thumbnailUrl]="video.image">
                </app-video-player>
              </div>
            </div>
            <div class="position-relative">
              <div class="video-title text-overflow-ellipses">
                {{ video.title }}
              </div>
            </div>
          </div>
        } @empty {
          <div class="col-12 text-center text-muted my-5">
            <i class="iconoir-media-video-xmark fs-1 my-3"></i>
            <p class="">No videos found</p>
          </div>
        }
      </div>
    } @else {
      <app-loader></app-loader>
    }

    <hr />
    <div class="row mt-3 align-items-center">
      <div class="col">
        @if (totalShown) {
          <div class="page-count text-sm-mobile mb-3">
            Showing <span class="text-black">{{ rowNumber }}</span> to
            <span class="text-black">{{ totalShown }}</span> of
            <span class="text-black">{{ count }}</span>
          </div>
        }
      </div>
      <div class="col-auto">
        @if (count > 0) {
          <pagination
            [(ngModel)]="page"
            [totalItems]="count"
            [itemsPerPage]="page_size"
            [maxSize]="5"
            [rotate]="false"
            (pageChanged)="onChange($event)"
            [customPreviousTemplate]="prevTemplate"
            [customNextTemplate]="nextTemplate"></pagination>
        }
        <ng-template #prevTemplate>Prev</ng-template>
        <ng-template #nextTemplate>Next</ng-template>
      </div>
    </div>
  </div>
</div>
